
export const environment = {
  production: false,
  apiUrl: process.env.REACT_APP_API_URL,
};
